var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"view"},[_c('div',{staticClass:"team"},[_c('div',{staticClass:"top"},[_vm._v("\n\t\t\t\tDyelec Lesotho Directors\n\t\t\t")]),_c('div',{staticClass:"people"},_vm._l((_vm.directors),function(team_member,index){return _c('team-member',{key:index,attrs:{"index":index,"team_member":team_member}})}),1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }